import styled from "styled-components";

const InventoryWrapper = styled.div`
.items-menu{
  display: flex;
  flex-direction: column;
  padding-block: 8px;
  span{
    cursor: pointer;
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    color:${({ theme }) => theme['table-text']};
    padding: 4px 12px;
    &:hover{
      background-color: ${({ theme }) => theme['table-header-color']};
    }
  }
}
  .sku-bar {
    border: 1px solid #E8ECF1;
    padding: 12px 16px;
    margin-bottom: 16px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .sku-inputs {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
  .d-flex.align-items-end.gap-3.add-sku-btn.new-sku-button button {
    width: 124px;
}
  .card-overlay-opulent {
    border-bottom: 1px solid #ddd;
    padding-bottom: 8px;
    border-bottom: 1px solid #E3E6EF;
}
  .card-item-wrapper{
    border-bottom: none !important;
    padding-bottom: 8px;
    .card-item-content {
    width: 480px;
    .product-name{
      width: 470px;
    }
}
  }
  .QB-dataTable .ag-cell-expandable .ag-group-value {
    margin-top: 6px;
}
  .modal-inner-wrapper-sku{
    display: flex;
    align-items: end;
    justify-content: space-between;
  }

  .uploaded-file-container {
    display: flex;
    flex-direction: column;
    grid-row-gap: 8px;
    max-height: 100px;
    overflow: auto;
    .uploading-content-data {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    span {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: ${({ theme }) => theme['body-text-color']};
    svg{
        font-size: 16px;
        color: ${({ theme }) => theme['danger-hover']};
        cursor:pointer;
    }
}
}
}
}

  .sku-map-select{
    & > div{
      height: auto;
      padding: 3px 0px;
    }
    .ant-select-selection__rendered{
      height:45px;
    }
    .option-product {
    padding-block: 4px;
}
  }
  .box-row {
    margin-bottom: 16px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    width: 100%;
    gap: 10px;
    .sku-box {
      padding: 8px 14px;
      width: 100%;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      flex: 1;
      cursor: pointer;
      transition: all 0.15s ease;
      &.active-box {
        box-shadow: 0 0 0 2px currentColor;
      }
      h4 {
        color: ${({ theme }) => theme["heading-color"]};
        font-size: 16px;
        margin-bottom: 0;
        line-height: 1.2;
      }
      p {
        color: #6B7280;
        font-size: 10px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        margin-bottom: 2px;
      }
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      }
      &.box-purple {
        background: rgba(104, 72, 186, 0.06);
        border: 1px solid rgba(104, 72, 186, 0.2);
        color: #6848BA;
      }
      &.box-blue {
        background: rgba(21, 101, 216, 0.06);
        border: 1px solid rgba(21, 101, 216, 0.2);
        color: #1565D8;
      }
      &.box-red {
        background: rgba(217, 80, 64, 0.06);
        border: 1px solid rgba(217, 80, 64, 0.2);
        color: #D95040;
      }
      &.box-yellow {
        background: rgba(242, 189, 66, 0.06);
        border: 1px solid rgba(242, 189, 66, 0.2);
        color: #D4A017;
      }
      &.box-green {
        background: rgba(88, 165, 93, 0.06);
        border: 1px solid rgba(88, 165, 93, 0.2);
        color: #58A55D;
      }
      &.box-orange {
        background: rgba(255, 153, 0, 0.06);
        border: 1px solid rgba(255, 153, 0, 0.2);
        color: #FF9900;
      }
    }
  }
  .title-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    span{
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme['table-text']};
  }
  .upc-code{
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    color: ${({ theme }) => theme['body-text-color']};
    
  }
}
  .product-title {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 86%;
    .product-img {
      border-radius: 6px;
      min-width: 32px;
      width: 32px;
      height: 32px;
      object-fit: contain;
      border: 1px solid #F0F2F5;
    }
    .product-name {
      font-size: ${({ theme }) => theme["medium-font-size"]};
      font-weight: 500;
      color: #1B2559;
      display: block;
      margin-bottom: 2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.max {
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .asin {
      padding: 2px 6px;
      background-color: #F0F4FF;
      color: #1565D8;
      border: 1px solid #D6E4FF;
      font-size: ${({ theme }) => theme["font-size-small"]};
      border-radius: 6px;
      line-height: normal;
      display: flex;
      align-items: center;
      gap: 2px;
      max-width: max-content;
      span {
        display: flex;
        gap: 2px;
        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: block;
        }
      }
      &.sku {
        background-color: #F5F5F5;
        color: #4E5969;
        border: 1px solid #E8ECF1;
      }
      &.qty {
        background-color: #F0F4FF;
        color: #1565D8;
        border: 1px solid #D6E4FF;
      }
    }
  }
  .fnsku {
    padding: 2px 6px;
    background-color: #FFF7E6;
    color: #D4760A;
    border: 1px solid #FFE0A3;
    font-size: ${({ theme }) => theme["font-size-small"]};
    border-radius: 6px;
    line-height: normal;
    display: flex;
    align-items: center;
    gap: 2px;
    max-width: max-content;
    span {
      display: flex;
      gap: 2px;
    }
  }
  &.sku-modal {
    padding-top: 0;
    h4 {
      font-size: 18px;
      color: ${({ theme }) => theme['primary-color']};
    }
    .select2-container .select2-selection__control {
      min-height: 37px;
      max-height: 37px;
      .select2-selection__placeholder {
        color: ${({ theme }) => theme['placeholder-color']};
      }
    }
    .inputs-height {
      max-height: 210px;
      overflow: auto;
      padding-bottom: 130px;
      padding-right: 12px;
    }
    .map-height {
      max-height: 220px;
      overflow: auto;
      padding-right: 12px;
    }
  }
  .sizes {
    span {
      font-size: ${({ theme }) => theme["font-size-small"]};
      line-height: 16px;
      display: flex;
      gap: 4px;
      span {
        color: #231F20;
        font-weight: bold;
        font-size: ${({ theme }) => theme["base-font-size-small"]};
      }
    }
  }
  .date-active {
    span {
      display: block;
      &:nth-child(2) {
        font-size: ${({ theme }) => theme["font-size-small"]};
      }
    }
  }
  .item-note {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ant-table-fixed-header .ant-table-scroll .ant-table-header {
    padding-bottom: 4px;
    padding-right: 0;
  }
  .history-btn {
    margin-top: 21px;
  }
  .add-btn {
    button {
      margin-top: 22px;
      height: 38px;
      font-size: 20px;
      line-height: 0;
    }
    .delete-btn {
      border-color: ${({ theme }) => theme["danger-color"]};
    }
  }
  .add-sku-btn {
    button {
      font-size: ${({ theme }) => theme["medium-font-size"]};
      width: 80px;
      height: 38px;
    }
  }

.search-sku {
  margin-top: -4px;
  label {
    margin-bottom: 4px;
    color: ${({ theme }) => theme["regent_gray"]};
    font-size: ${({ theme }) => theme["base-font-size-small"]};
  }
  .ant-select {
    color: ${({ theme }) => theme['cutty_sark']};
  }
  .ant-select-selection {
    border: 1px solid #CFD8DC;
    height: 38px;
    &:focus {
      outline: none;
      box-shadow: none;
    }
    &:active {
      box-shadow: none;
    }
    .ant-select-selection__rendered {
      line-height: 36px;
    }
    .ant-select-arrow {
      color: ${({ theme }) => theme["primary-color"]};
    }
  }
}
.option-product {
  border-bottom: 1px solid ${({ theme }) => theme["border-color-normal"]}; 
  padding-bottom: 8px;
  .product-name {
    font-size: ${({ theme }) => theme["base-font-size-small"]};
    line-height: 16px;
    margin-bottom: 4px;
  }
}
.no-data {
  h6 {
    color: ${({ theme }) => theme["regent_gray"]};
    font-weight: ${({ theme }) => theme["bold-weight"]};
    line-height: 24px;
  }
}
.required {
  color: red;
  font-weight: bold;
}
.cogs-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  
  th, td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
    font-size: 12px;
  }
  
  th {
    background-color: #fafafa;
    font-weight: 600;
    color: #1b2559;
  }
  
  td {
    color: #4e5969;
  }
  
  tr:last-child td {
    border-bottom: none;
  }
}
.border-bottom-dotted {
  border-bottom: 1px dotted #1565D8;
}
.modal-grid {
  .QB-dataTable {
    height: 400px !important;
    margin-top: 0;
  }
}
.sku-modal {
  padding-top: 0;
  h4 {
    font-size: 18px;
    color: ${({ theme }) => theme['primary-color']};
  }
}
`
export const TableStyleWrapper = styled.div`
background: #FAFBFC;
border-left: 3px solid #E8ECF1;
padding: 8px 12px;
.button-wrapper{
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  border: none;
  border-radius: 6px;
  min-width: 79px;
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: ${({ activeTabs }) => activeTabs === 'sku' ? '#1565D8' : 'transparent'};
  color: ${({ activeTabs }) => activeTabs === 'sku' ? '#FFFFFF' : '#6B7280'};
  &:not(:first-child){
    background-color: ${({ activeTabs }) => activeTabs === 'vendor' ? '#1565D8' : 'transparent'};
    color: ${({ activeTabs }) => activeTabs === 'vendor' ? '#FFFFFF' : '#6B7280'};
  }
  &:hover{
    background-color: ${({ activeTabs }) => activeTabs === 'sku' ? '#1565D8' : '#F0F2F5'};
    border-color: transparent;
    color: ${({ activeTabs }) => activeTabs === 'sku' ? '#FFFFFF' : '#4E5969'};
  }
  &:not(:first-child):hover{
    background-color: ${({ activeTabs }) => activeTabs === 'vendor' ? '#1565D8' : '#F0F2F5'};
    color: ${({ activeTabs }) => activeTabs === 'vendor' ? '#FFFFFF' : '#4E5969'};
  }
}
.map-btn-wrapper{
  background-color: #1565D8 !important;
  color: #FFFFFF !important;
  border: none !important;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 14px;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover{
    filter: brightness(0.92);
  }
}
.css-1dimb5e-singleValue {
    color: #78909C;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.css-1jqq78o-placeholder {
    grid-area: 1 / 1 / 2 / 3;
    color: #ccc;
    margin-left: 2px;
    margin-right: 2px;
    box-sizing: border-box;
    font-size: 12px;
}
.add-vendor-btn-wrapper{
    text-align: center;
    color: rgb(21, 101, 216);
    border-radius: 4px;
    margin: 0px;
    font-size: 14px;
    font-weight: 400;
    padding:8px;
    margin: auto;
    margin-top: 3px;
    cursor: pointer;
    position: sticky;
    bottom: 0;
    background: #fff;
    width: 100%;
    right: 0;
}
div#react-select-3-listbox {
    padding-bottom: 0;
}
.css-19jrirr-control {
    border-radius: 4px;
}
.ag-body-viewport.ag-row-no-animation.ag-layout-auto-height {
    max-height: 200px;
    overflow: auto;
    min-height: 100px;
}
.card-item-wrapper {
  h6 {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #1565D8;
    margin-bottom: 31px;
}
.product-title {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 86%;
    .product-img {
      border-radius: 6px;
      min-width: 32px;
      width: 32px;
      height: 32px;
      object-fit: contain;
      border: 1px solid #F0F2F5;
    }
    .product-name {
      font-size: ${({ theme }) => theme["medium-font-size"]};
      font-weight: 500;
      color: #1B2559;
      display: block;
      margin-bottom: 2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.max {
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .asin {
      padding: 2px 4px 2px 2px;
      background-color: #576D80;
      color: ${({ theme }) => theme["white-color"]};
      font-size: ${({ theme }) => theme["font-size-small"]};
      border-radius: 4px;
      line-height: normal;
      display: flex;
      align-items: center;
      gap: 2px;
      max-width: max-content;
      span {
        display: flex;
        gap: 2px;
        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: block;
        }
      }
      &.sku {
        background-color: #A1B2BE;
      }
      &.qty {
        background-color: #4E5969;
      }
    }
  }
}
.map-btn-wrapper{
    padding: 1px 6px;
    font-weight: 600;
    line-height: 22px;
    font-size: 12px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-color: #1565D8;
    color: #1565D8;
    &:not(:first-child){
      background-color: #1565D8;
      color: #fff;
    }
}
.ag-cell.ag-cell-not-inline-editing.ag-cell-normal-height.ag-cell-value {
  color: #535E63;
    &:not(:last-child){
      border-right: 1px solid #E0E0E0;
    }
}
.ag-row-odd.ag-row-no-focus.ag-row.ag-row-level-0.ag-row-position-absolute{
  border-color: #E0E0E0;
}
.alert-popover-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 3px;
}

.alert-popover-wrapper span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #535E63;
}
.alert-popover-icons-wrapper {
    display: flex;
    align-items: end;
    justify-content: end;
    margin-top: 7px;
    grid-gap: 4px;
    button {
    padding: 0px 6px;
    font-weight: 400;
    height:19px;
    font-size: 12px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-color: #1565D8;
    color: #1565D8;
    &:not(:first-child){
      background-color: #1565D8;
      color: #fff;
    }
}
}
.upc-item-wrapper {
    display: flex;
    flex-direction: column;
    span {
    font-size: 10px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #808183;
}
p {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0px;
    color: #535E63;
}
}
`
export const MappingAlertWrapper = styled.div`
 .ag-cell {
  &:not(:first-child){
    border-left: 1px solid #E0E0E0;
  }
}
`

export default InventoryWrapper;
